"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.register = register;
exports.saveForPrefill = saveForPrefill;
exports.resetRegister = resetRegister;
exports.login = login;
exports.logout = logout;
exports.verifyEmail = verifyEmail;
exports.resetPassword = resetPassword;
exports.passwordChange = passwordChange;
exports.userUpdate = userUpdate;

var _browserCookies = require("browser-cookies");

var _browserCookies2 = _interopRequireDefault(_browserCookies);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _ShoppingCartUtil = require("../../utils/ShoppingCartUtil");

var _vouchers = require("./vouchers");

var _pickupVouchers = require("./pickupVouchers");

var _VoucherUtil = require("../../utils/VoucherUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = "maaporssi/auth/LOAD";
var LOAD_SUCCESS = "maaporssi/auth/LOAD_SUCCESS";
var LOAD_FAIL = "maaporssi/auth/LOAD_FAIL";
var REGISTER = "maaporssi/auth/REGISTER";
var REGISTER_SUCCESS = "maaporssi/auth/REGISTER_SUCCESS";
var REGISTER_FAIL = "maaporssi/auth/REGISTER_FAIL";
var REGISTER_RESET = "maaporssi/auth/REGISTER_RESET";
var LOGIN = "maaporssi/auth/LOGIN";
var LOGIN_SUCCESS = "maaporssi/auth/LOGIN_SUCCESS";
var LOGIN_FAIL = "maaporssi/auth/LOGIN_FAIL";
var LOGOUT = "maaporssi/auth/LOGOUT";
var LOGOUT_SUCCESS = "maaporssi/auth/LOGOUT_SUCCESS";
var LOGOUT_FAIL = "maaporssi/auth/LOGOUT_FAIL";
var VERIFY_EMAIL = "maaporssi/auth/VERIFY_EMAIL";
var VERIFY_EMAIL_SUCCESS = "maaporssi/auth/VERIFY_EMAIL_SUCCESS";
var VERIFY_EMAIL_FAIL = "maaporssi/auth/VERIFY_EMAIL_FAIL";
var SAVE_FOR_PREFILL = "maaporssi/auth/SAVE_FOR_PREFILL";
var PASSWORD_RESET = "maaporssi/auth/PASSWORD_RESET";
var PASSWORD_RESET_SUCCESS = "maaporssi/auth/PASSWORD_RESET_SUCCESS";
var PASSWORD_RESET_FAIL = "maaporssi/auth/PASSWORD_RESET_FAIL";
var CHANGE_PASSWORD = "maaporssi/auth/CHANGE_PASSWORD";
var CHANGE_PASSWORD_SUCCESS = "maaporssi/auth/CHANGE_PASSWORD_SUCCESS";
var CHANGE_PASSWORD_FAIL = "maaporssi/auth/CHANGE_PASSWORD_FAIL";
var UPDATE_USER = "maaporssi/auth/UPDATE_USER";
var UPDATE_USER_SUCCESS = "maaporssi/auth/UPDATE_USER_SUCCESS";
var UPDATE_USER_FAIL = "maaporssi/auth/UPDATE_USER_FAIL";

var initialState = {
  loaded: false
};
var loginInfo = { email: "", password: "" };
var regData = [];

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _vouchers.CHANGE_ORDER_TYPE:
    case _pickupVouchers.CHANGE_ORDER_TYPE:
      return (0, _extends3.default)({}, state, {
        orderType: action.payload
      });
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        error: action.error.error
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result
      });
    case REGISTER:
      return (0, _extends3.default)({}, state, {
        registrationLoading: true
      });
    case REGISTER_FAIL:
      // loginInfo.email = '';
      // loginInfo.password = '';
      return (0, _extends3.default)({}, state, {
        registrationLoading: false,
        registrationSuccess: false,
        registrationError: action.error.error
      });
    case REGISTER_RESET:
      return (0, _extends3.default)({}, state, {
        registrationLoading: false,
        registrationSuccess: false,
        registrationError: null
      });
    case REGISTER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        registrationLoading: false,
        registrationSuccess: true,
        registrationError: null,
        loginInfo: loginInfo,
        regData: regData
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loginLoading: true,
        loginInfo: loginInfo,
        regData: regData
      });
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loginLoading: false,
        loginError: action.error.error,
        loginSuccess: false
      });
    case LOGIN_SUCCESS:
      // onsole.log('auth.js LOGIN_SUCCESS');
      // console.dir(regData);
      _browserCookies2.default.set(_config2.default.tokenCookie, action.result.token);
      return (0, _extends3.default)({}, state, {
        loginLoading: false,
        user: action.result.user,
        loginError: null,
        loginInfo: loginInfo,
        regData: regData
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state, {
        logoutLoading: true
      });
    case LOGOUT_SUCCESS:
      _browserCookies2.default.erase(_config2.default.tokenCookie);
      window.location = _config2.default.home;
      return state;

    case VERIFY_EMAIL:
      return (0, _extends3.default)({}, state, {
        verifyEmailLoading: true
      });
    case VERIFY_EMAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        verifyEmailLoading: false,
        verifyEmailError: true
      });
    case VERIFY_EMAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        verifyEmailLoading: false,
        verifyEmailSuccess: true
      });
    case PASSWORD_RESET:
      return (0, _extends3.default)({}, state, {
        resetLoading: true
      });
    case PASSWORD_RESET_FAIL:
      return (0, _extends3.default)({}, state, {
        resetLoading: false,
        resetSuccess: false,
        resetError: action.error.error
      });
    case PASSWORD_RESET_SUCCESS:
      return (0, _extends3.default)({}, state, {
        resetLoading: false,
        resetSuccess: true,
        resetError: null
      });
    case CHANGE_PASSWORD:
      return (0, _extends3.default)({}, state, {
        changePasswordLoading: true
      });
    case CHANGE_PASSWORD_FAIL:
      return (0, _extends3.default)({}, state, {
        changePasswordLoading: false,
        changePasswordSuccess: false,
        changePasswordError: action.error.error
      });
    case CHANGE_PASSWORD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        changePasswordLoading: false,
        changePasswordSuccess: true,
        changePasswordError: null
      });
    case UPDATE_USER:
      return (0, _extends3.default)({}, state, {
        userUpdateLoading: true
      });
    case UPDATE_USER_FAIL:
      return (0, _extends3.default)({}, state, {
        userUpdateLoading: false,
        userUpdateSuccess: false,
        userUpdateError: action.error.error
      });
    case UPDATE_USER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        userUpdateLoading: false,
        userUpdateSuccess: true,
        userUpdateError: null,
        user: action.result
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get("/auth/user");
    }
  };
}

function register(formData) {
  loginInfo.email = formData.email;
  loginInfo.password = formData.password;
  regData = formData;

  return {
    types: [REGISTER, REGISTER_SUCCESS, REGISTER_FAIL],
    promise: function promise(client) {
      return client.post("/auth/register", {
        data: formData
      });
    }
  };
}

function saveForPrefill(formData) {
  var firstName = formData.contact_person_name.split(" ").slice(0, -1).join(" ");
  var lastName = formData.contact_person_name.split(" ").slice(-1).join(" ");
  return {
    type: SAVE_FOR_PREFILL,
    payload: {
      first_name: firstName,
      last_name: lastName,
      phone: formData.contact_person_phone,
      email: formData.contact_person_email
    }
  };
}

function resetRegister() {
  return {
    type: REGISTER_RESET
  };
}

function login(formData) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post("/auth/login", {
        data: formData
      });
    }
  };
}

function logout() {
  (0, _ShoppingCartUtil.removeItems)(_VoucherUtil.RECEPTION_ORDER_TYPE);
  (0, _ShoppingCartUtil.removeItems)(_VoucherUtil.PICKUP_ORDER_TYPE);
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: function promise(client) {
      return client.get("/auth/logout");
    }
  };
}

function verifyEmail(token) {
  return {
    types: [VERIFY_EMAIL, VERIFY_EMAIL_SUCCESS, VERIFY_EMAIL_FAIL],
    promise: function promise(client) {
      return client.get("/auth/confirm/" + token);
    }
  };
}

function resetPassword(formData) {
  return {
    types: [PASSWORD_RESET, PASSWORD_RESET_SUCCESS, PASSWORD_RESET_FAIL],
    promise: function promise(client) {
      return client.post("/auth/reset_password", {
        data: formData
      });
    }
  };
}

function passwordChange(formData) {
  return {
    types: [CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAIL],
    promise: function promise(client) {
      return client.post("/auth/new_password", {
        data: formData
      });
    }
  };
}

function userUpdate(userId, formData) {
  return {
    types: [UPDATE_USER, UPDATE_USER_SUCCESS, UPDATE_USER_FAIL],
    promise: function promise(client) {
      return client.put("/users/" + userId, {
        data: formData
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/auth.js
 ** module id = 64
 ** module chunks = 0
 **/